import { Text, TextLink } from '@oneaudi/unified-web-alpha-components';
import { useI18n } from '~/app/i18n/i18n';
import { Disclaimer } from '~/components/disclaimer/disclaimer';
import { TileInformationContainer } from '~/components/image-selection-tile/style/tile-selection-section-style';
import { Prices } from '~/components/prices';
import { RenderHtml } from '~/components/text/render-html';
import { FilteredItem } from '~/graphql/types';
import { isDisclaimerAvailable } from '~/utils/date';

export const TileInformation = ({ item, id, price_id }: { item?: FilteredItem; id?: string; price_id?: string }) => {
	const { i18n } = useI18n();

	if (!item) return null;

	return (
		<TileInformationContainer>
			<Text className="title" aria-hidden tag="p" variant={{ type: 'copy', order: '2', style: 'bold' }}>
				<RenderHtml id={id} html={item?.name} />
			</Text>
			<div>
				{item.price &&
					(item.standard ? (
						<Text tag="p" variant={{ type: 'copy', order: '3', style: 'normal' }}>
							{i18n('ngc.common.standard')}
						</Text>
					) : (
						<Prices
							id={price_id}
							totalPrice={item.price.totalPrice}
							pr7={item.key}
							vatConfig={item.price.feature}
							size="3"
						/>
					))}
			</div>
			{item.showRenderDisclaimer && item.selected && (
				<Text tag={'p'} variant={{ type: 'copy', order: '2', style: 'normal' }}>
					{i18n('ngc.common.note')}: {i18n('ngc.remarks.optionNotShownInImages')}
				</Text>
			)}
			{item.textLink && (
				<TextLink
					margin={['4px', 0, 0, 0]}
					size="sm"
					variant="standalone"
					onClick={item.textLink.onTextLinkClick}>
					{item.textLink.label}
				</TextLink>
			)}
			{item.disclaimerContent && isDisclaimerAvailable(item.disclaimerStartDate, item.disclaimerEndDate) && (
				<div className="disclaimer-wrapper">
					<Disclaimer type="item" headline={item.disclaimerHeadline} content={item.disclaimerContent} />
				</div>
			)}
		</TileInformationContainer>
	);
};
